export type GreetingPeriod = 'morning' | 'afternoon' | 'evening'

interface EventDateParts {
  month: string
  day: string
  time: string
}

const MORNING_FROM_HOUR = 5
const AFTERNOON_FROM_HOUR = 12
const EVENING_FROM_HOUR = 18

export function relativeChange(current: number, previous: number): number | null {
  if (!(previous > 0)) return null
  const change = (current - previous) / previous
  return Number.isFinite(change) ? change : null
}

export function formatChange(change: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    signDisplay: 'exceptZero',
    maximumFractionDigits: 0,
  }).format(change)
}

export function formatCount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function greetingPeriod(hour: number): GreetingPeriod {
  if (hour >= MORNING_FROM_HOUR && hour < AFTERNOON_FROM_HOUR) return 'morning'
  if (hour >= AFTERNOON_FROM_HOUR && hour < EVENING_FROM_HOUR) return 'afternoon'
  return 'evening'
}

export function todayLabel(now: number, locale: string): string {
  return new Intl.DateTimeFormat(locale, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(now)
}

export function eventDateParts(startTime: string, locale: string): EventDateParts {
  const start = new Date(startTime)
  return {
    month: new Intl.DateTimeFormat(locale, { month: 'short' }).format(start),
    day: new Intl.DateTimeFormat(locale, { day: 'numeric' }).format(start),
    time: new Intl.DateTimeFormat(locale, {
      weekday: 'short',
      hour: 'numeric',
      minute: '2-digit',
    }).format(start),
  }
}
